import { BackButton } from '@components/buttons';
import AddClientInstallationForm from 'modules/client-installation/components/AddClientInstallationForm/AddClientInstallationForm';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';

const AddClientInstallationpage = () => {
    return (
        <PageTemplate>
            <BackButton to={`/client-installations`} />
            <PageHeading>
                <div className="flex gap-2">Add Client For Installation</div>
            </PageHeading>

            <AddClientInstallationForm />
        </PageTemplate>
    );
};

export default AddClientInstallationpage;
